import { useContext, useState, useEffect } from "react"
import "./css/CustomiseForm.css"
import { BiArrowBack, BiCheckCircle, BiSolidCheckCircle } from "react-icons/bi"
import { DashboardState } from "./Dashboard"
import { useNavigate } from "react-router"
import { AiOutlineOrderedList } from "react-icons/ai"
import { SiPeakdesign } from "react-icons/si"
import { IoSettingsOutline } from "react-icons/io5"
import { MdDeleteOutline, MdOutlineDragIndicator } from "react-icons/md"
import { SpinnerCircular, SpinnerRoundFilled } from 'spinners-react'
import CustomisedForm from "../components/CustomisedForm"
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import axios from "axios"
import api from "../config/backend"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import LightThumbnail from "../assets/Light theme thmbnail.png"
import DarkThumbnail from "../assets/Dark theme thmbnail.png"
import Configurations from "../components/Configurations"
import CustomField from "../components/CustomField"
import { toast } from "react-toastify"
import { Button, IconButton } from "@mui/material"
import { Link } from "react-router-dom"
import { ArrowBackIos, ChevronRight, Close } from "@mui/icons-material"
import { Scrollbar } from "react-scrollbars-custom"

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
};

const CustomiseForm = () => {
    const [activeTab, setActiveTab] = useState(0)
    const [popup, setPopup] = useState(false)
    const [formdata, setFormdata] = useState(undefined)
    const [title, setTitle] = useState("")
    const [submitButton, setSubmitButton] = useState("")
    const [loading, setLoading] = useState(false)
    const [editing, setEditing] = useState("")
    const [editfields, setEditfields] = useState(undefined)
    const [popupComponent, setPopupComponent] = useState(undefined)
    const [instantReorder, setInstantReorder] = useState([])
    const [triggerRefresh, setTriggerRefresh] = useState(0)
    const [isRequired, setIsRequired] = useState(false);

    const { state, actions } = useContext(DashboardState)

    const token = localStorage.getItem("_crm__token")

    const navigate = useNavigate()

    const fetchForm = async () => {
        const { data, status } = await axios.post(`${api}/Form/fetch-details`, { token })

        if (data.success) {
            setTitle(data.form.title)
            setSubmitButton(data.form.submit)
            setFormdata(data.form)
            setInstantReorder(data.form.inputs)
        } else {
            console.log({ data })
        }
    }
console.log(formdata)
    const handleTheme = async (theme) => {
        const { data, status } = await axios.post(`${api}/Form/toggle-theme`, { token, theme })

        if (data.success) {
            setFormdata(data.form)
        } else {
            console.log({ data })
        }
    }

    const handleCover = async () => {
        setLoading("update-cover")
        const { data, status } = await axios.post(`${api}/Form/update-cover`, { token, title, submit: submitButton })

        setLoading(false)

        if (data.success) {
            setTitle(data.form.title)
            setSubmitButton(data.form.submit)
            setFormdata(data.form)
        } else {
            console.log({ data })
        }
    }
    console.log(editfields)
    const handleInputs = async () => {
        setLoading("update-inputs");


        const payload = {
            token,
            fieldname: editfields.fieldname,
            fielddata: editfields.data,
            required: editfields.required,
        };

        const { data, status } = await axios.post(`${api}/Form/update-inputs`, payload);

        setLoading(false);

        if (data.success) {
            setFormdata(data.form);
            setEditfields(undefined);
            setEditing("");
            setPopup(false);
        } else {
            console.log({ data });
        }
    };

    const toggleField = async (fieldname, currentstatus) => {
        setLoading("toggle-inputs")
        const { data, status } = await axios.post(`${api}/Form/toggle-inputs`, { token, fieldname, active: currentstatus ? false : true })

        setLoading(false)

        if (data.success) {
            setFormdata(data.form)
            setInstantReorder(data.form.inputs)
        } else {
            console.log({ data })
        }
    }

    useEffect(() => {
        fetchForm()
    }, [triggerRefresh])

    useEffect(() => {
        if (editing) {
            const toedit = formdata.inputs.find(item => item.fieldname === editing)

            setEditfields(toedit)
        }
    }, [editing])

    // Function to update list on drop
    const handleDrop = async (droppedItem) => {
        if (!droppedItem.destination) return

        var forminputs = [...formdata.inputs]
        // Remove dragged item
        const [reorderedItem] = forminputs.splice(droppedItem.source.index, 1)
        // Add dropped item
        forminputs.splice(droppedItem.destination.index, 0, reorderedItem)

        setInstantReorder(forminputs)

        // Update State
        const { data, status } = await axios.post(`${api}/Form/reorder-inputs`, { token, forminputs })

        if (data.success) {
            setFormdata(data.form)
        } else {
            console.log({ data })
        }
    }

    // Delete a custom input field
    const handleDelete = async (fieldname) => {
        const { data, status } = await axios.post(`${api}/Form/delete-custom`, { token, fieldname })

        if (data.success) {
            setFormdata(data.form)
        } else {
            toast.error(data.message)
        }
    }

    console.log({ formdata })

    return (
        <>
            {formdata ? (
                <div>
                    <Modal
                        open={popup}
                        onClose={() => {
                            setPopup(false)
                            setEditfields(undefined)
                            setEditing("")
                            setPopupComponent(undefined)
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        {popupComponent ? (
                            <div className="app-modal-managefields__wrapper">
                                <div className="app-modal-managefields__card">
                                    <div className="app-modal-managefields__header">
                                        <div>
                                            <h4>Manage fields</h4>
                                            <p>Toggle visibility of fields in form</p>
                                        </div>
                                        <IconButton onClick={() => {
                                            setPopup(false)
                                            setPopupComponent(undefined)
                                        }} size="small">
                                            <Close />
                                        </IconButton>
                                    </div>
                                    <div className="app-modal-managefields__body">
                                        <ul className="managefields__list">
                                            {formdata.inputs.map(item => {
                                                return (
                                                    <li className={item.active ? "managefields__listitem --active" : "managefields__listitem"} onClick={() => toggleField(item.fieldname, item.active)}>
                                                        <div className="managefields__card">
                                                            {item.active ? <BiSolidCheckCircle /> : <BiCheckCircle />}
                                                            <span>{item.fieldname}</span>
                                                        </div>
                                                        {item.protected ? undefined : <IconButton style={{ color: "#d11a2a", padding: "0" }} size="small" onClick={e => {
                                                            e.stopPropagation()
                                                            handleDelete(item.fieldname)
                                                        }
                                                        }><MdDeleteOutline /></IconButton>}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        <div>
                                            <CustomField setTriggerRefresh={setTriggerRefresh} />
                                        </div>
                                    </div>
                                    <div className="app-modal-managefields__footer">
                                        <Button
                                            variant="contained"
                                            className="app-btn-contained app-btn-primary"
                                            onClick={() => {
                                                setPopup(false)
                                                setPopupComponent(undefined)
                                            }}
                                        >Save</Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* {editfields ? <div className="_7gca">
                                    <span className="piranha-nags">{editfields.fieldname}</span>
                                    <div className="pavisses-yeti">
                                        {Object.keys(editfields.data).map((item) => {
                                            console.log(item)
                                            return (
                                                <div className="madrasas-flan" key={item}>
                                                    <label>{item ? `${item[0].toUpperCase()}${item.slice(1,)}` : undefined}</label>
                                                    <input
                                                        value={editfields.data[item]}
                                                        onChange={(e) =>
                                                            setEditfields((prev) => {
                                                                console.log("====", copy)
                                                                const copy = JSON.parse(JSON.stringify(prev));
                                                                copy.data[item] = e.target.value;
                                                                return copy;
                                                            })
                                                        }
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <button className="ironic-gyre" onClick={() => handleInputs()}>Update</button>
                                </div> : undefined} */}
                                {editfields ? (
                                    <div>
                                        <div className="app-modal-managefields__wrapper">
                                            <div className="app-modal-managefields__card">
                                                <div className="app-modal-managefields__header">
                                                    <h4>Update {editfields.fieldname}</h4>
                                                    <IconButton onClick={() => setPopup(false)} size="small">
                                                        <Close />
                                                    </IconButton>
                                                </div>
                                                <div className="app-modal-managefields__body">
                                                    <div className="app-modal-updatefields__body">
                                                        {Object.keys(editfields.data).map((item) => {
                                                            console.log(item)
                                                            console.log(editfields)
                                                            if (Array.isArray(editfields.data[item])) {
                                                        
                                                                return editfields.data[item].map((option, index) => (
                                                                    <div className="app-component-customizable-form__field" key={index}>
                                                                        <label className="app-component-customizable-form__field--label">Options</label>
                                                                        <input
                                                                            className="app-component-customizable-form__field--input"
                                                                            value={option}
                                                                            onChange={(e) => {
                                                                                setEditfields((prev) => {
                                                                                    const copy = JSON.parse(JSON.stringify(prev));
                                                                                    copy.data[item][index] = e.target.value;
                                                                                    return copy;
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ));
                                                            } else {
                                                                return (
                                                                    <div className="app-component-customizable-form__field" key={item}>
                                                                        <label className="app-component-customizable-form__field--label">{item ? `${item[0].toUpperCase()}${item.slice(1,)}` : undefined}</label>
                                                                        <input
                                                                            className="app-component-customizable-form__field--input"
                                                                            value={editfields.data[item]}
                                                                            onChange={(e) =>
                                                                                setEditfields((prev) => {
                                                                                    const copy = JSON.parse(JSON.stringify(prev));
                                                                                    copy.data[item] = e.target.value;
                                                                                    return copy;
                                                                                })
                                                                            }
                                                                        />

                                                                    </div>
                                                                );
                                                            }

                                                        })}
                                                        <div className="app-component-customizable1">
                                                           
                                                            <input
                                                                type="checkbox"
                                                                checked={editfields.required || false}
                                                                onChange={() => setEditfields((prev) => ({ ...prev, required: !prev.required }))}
                                                            />
                                                             <label className="app-component-customizable-form1">Make it mandatory</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="app-modal-managefields__footer">
                                                    <Button
                                                        variant="contained"
                                                        className="app-btn-contained app-btn-primary"
                                                        onClick={() => handleInputs()}
                                                    >Update</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : undefined}


                            </>)}
                    </Modal>
                    <div className="app-page-customize-form">
                        <div className="app-page-form__header">
                            <div className="app-page-form__header--title">
                                <h4>Customize Form</h4>
                                <ul className="app-breadcrumb-list">
                                    <li className="app-breadcrumb-listitem"><Link to="/forms">Form</Link></li>
                                    <li className="app-breadcrumb-listitem app-breadcrumb-listitem--icon"><ChevronRight /></li>
                                    <li className="app-breadcrumb-listitem">Customize form</li>
                                </ul>
                            </div>
                            <div className="app-page-form__header--actions">
                                <Button className={`app-btn-text ${activeTab === 2 ? "active" : undefined}`} onClick={() => setActiveTab(2)}>  <IoSettingsOutline style={{ marginRight: "6px" }} /> Configurations</Button>
                                <Button variant="contained" className="app-btn-contained app-btn-primary" onClick={() => { navigate("/forms") }}><ArrowBackIos style={{ fontSize: "14px" }} /> Back</Button>
                            </div>
                        </div>
                        <div className="app-page-customize-form__body">
                            {(activeTab === 0 || activeTab === 1) ? (
                                <div className="app-page-customize-form__mainlayout">
                                    <div className="app-page-customize-form__output">
                                        <div className="app-page-customize-form__output--form">
                                            <Scrollbar style={{ height: "calc(100vh - 190px)" }}>
                                                <CustomisedForm form={formdata} />
                                            </Scrollbar>
                                        </div>
                                    </div>
                                    <div className="app-page-customize-form__sidebar">
                                        <div className="app-page-customize-form__sidebar--tabs">
                                            <ul>
                                                <li>
                                                    <Button className={`${activeTab === 0 ? "active" : ""}`} onClick={() => setActiveTab(0)}>
                                                        Fields
                                                    </Button>
                                                </li>
                                                <li>
                                                    <Button className={`${activeTab === 1 ? "active" : ""}`} onClick={() => setActiveTab(1)}>
                                                        Design
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                        <Scrollbar style={{ height: "calc(100vh - 205px)" }}>

                                            <div className="app-page-customize-form__sidebar--content">
                                                {activeTab === 0 ? (
                                                    <div className="app-customize-tab__form">
                                                        <div className="app-customize-tab__form--head">
                                                            <h3>Add fields to your form</h3>
                                                            <p>Choose which fields you need on your form</p>
                                                            <Button
                                                                variant="outlined"
                                                                className="app-btn-contained"
                                                                onClick={() => {
                                                                    setPopupComponent("add-fields")
                                                                    setPopup(true)
                                                                }}>
                                                                Manage fields
                                                            </Button>
                                                        </div>
                                                        <div className="app-customize-tab__form--layoutfields">
                                                            <div className="app-customize-tab__form--layoutfields--head">
                                                                <h5>Form Layout Fields</h5>
                                                            </div>
                                                            <div className="app-form__group">
                                                                <div className="app-form__field">
                                                                    <label className="app-form__field--label">Title</label>
                                                                    <input className="app-form__field--input" value={title} onChange={e => setTitle(e.target.value)} />
                                                                </div>
                                                                <div className="app-form__field">
                                                                    <label className="app-form__field--label">Submit button</label>
                                                                    <input className="app-form__field--input" value={submitButton} onChange={e => setSubmitButton(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="app-customize-tab__form--layoutfields">
                                                                <Button variant="contained" className="app-btn-contained app-btn-primary" onClick={() => handleCover()}>
                                                                    {loading === "update-cover" ? <SpinnerCircular size={18} color="white" /> : "Save"}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        <div className="app-customize-tab__form--inputfields">
                                                            <div className="app-customize-tab__form--inputfields--head">
                                                                <h5>Form input Fields</h5>
                                                            </div>
                                                            <div className="app-customize-tab__form--draggables">
                                                                {/* Important: Disable strict mode to make it work in development mode */}
                                                                <DragDropContext onDragEnd={handleDrop}>
                                                                    <Droppable droppableId="list-container">
                                                                        {provided => (
                                                                            <div
                                                                                className="list-container"
                                                                                {...provided.droppableProps}
                                                                                ref={provided.innerRef}
                                                                            >
                                                                                {instantReorder.map((item, index) => {
                                                                                    return (
                                                                                        <Draggable key={item.fieldname} draggableId={item.fieldname} index={index}>
                                                                                            {(provided) => (
                                                                                                <div
                                                                                                    className="item-container"
                                                                                                    ref={provided.innerRef}
                                                                                                    {...provided.dragHandleProps}
                                                                                                    {...provided.draggableProps}
                                                                                                >
                                                                                                    <div className={item.active ? "app-draggable-item" : "app-draggable-item hidden"}>
                                                                                                        <div className="app-draggable-item__icon">
                                                                                                            <MdOutlineDragIndicator />
                                                                                                        </div>
                                                                                                        <div className="app-draggable-item__card">
                                                                                                            <span>{item.fieldname}</span>
                                                                                                            <IoSettingsOutline onClick={() => {
                                                                                                                setEditing(item.fieldname)
                                                                                                                setPopup(true)
                                                                                                            }} />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </Draggable>
                                                                                    )
                                                                                })}
                                                                                {provided.placeholder}
                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                </DragDropContext>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="app-customize-tab__design">
                                                        <div className="app-customize-tab__design--header">
                                                            <h4>Pick a theme</h4>
                                                            <p>Choose which theme should be applied to form</p>
                                                        </div>
                                                        <div className="app-customize-tab__design--content">
                                                            <ul>
                                                                <li onClick={() => handleTheme("Light")}>
                                                                    <img src={LightThumbnail} alt="Light theme thumbnail" />
                                                                    <span>Light</span>
                                                                </li>
                                                                <li onClick={() => handleTheme("Dark")}>
                                                                    <img src={DarkThumbnail} alt="Dark theme thumbnail" />
                                                                    <span>Dark</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </Scrollbar>
                                    </div>
                                </div>
                            ) : <Configurations formdata={formdata} />}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="app-page-customize-form__spinner">
                    <SpinnerRoundFilled size={60} />
                </div>
            )}
            
        </>
    )
}

export default CustomiseForm
